var _circle, _circle2, _circle3, _rect, _rect2, _rect3, _circle4, _circle5, _circle6, _text, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _path, _circle7, _circle8, _circle9, _circle0, _rect0, _circle1, _path2, _rect1, _rect10, _rect11, _text2, _text3, _rect12, _rect13, _path3, _path4, _circle10, _circle11, _circle12, _text4, _text5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoginIllustration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad1",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#ff6a00",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#ff8a33",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad2",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#3b82f6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#60a5fa",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad3",
    x1: "0%",
    y1: "100%",
    x2: "0%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#10b981",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#34d399",
      stopOpacity: 1
    }
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 80,
    r: 60,
    fill: "#ff6a00",
    opacity: 0.1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 320,
    r: 40,
    fill: "#3b82f6",
    opacity: 0.1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 450,
    cy: 350,
    r: 30,
    fill: "#10b981",
    opacity: 0.1
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 80,
    width: 260,
    height: 180,
    rx: 12,
    fill: "white",
    stroke: "#e2e8f0",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 80,
    width: 260,
    height: 45,
    rx: 12,
    fill: "#f8fafc"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 113,
    width: 260,
    height: 12,
    fill: "#f8fafc"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 145,
    cy: 102,
    r: 6,
    fill: "#ef4444"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 165,
    cy: 102,
    r: 6,
    fill: "#f59e0b"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 185,
    cy: 102,
    r: 6,
    fill: "#10b981"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 220,
    y: 108,
    fontFamily: "Arial",
    fontSize: 14,
    fill: "#64748b",
    fontWeight: 600
  }, "\u6570\u636E\u5206\u6790\u9762\u677F")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 200,
    width: 25,
    height: 40,
    rx: 4,
    fill: "url(#grad1)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 180,
    width: 25,
    height: 60,
    rx: 4,
    fill: "url(#grad2)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 215,
    y: 165,
    width: 25,
    height: 75,
    rx: 4,
    fill: "url(#grad1)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 250,
    y: 145,
    width: 25,
    height: 95,
    rx: 4,
    fill: "url(#grad3)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 285,
    y: 160,
    width: 25,
    height: 80,
    rx: 4,
    fill: "url(#grad2)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 135,
    width: 25,
    height: 105,
    rx: 4,
    fill: "url(#grad1)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M155 195 Q200 170 235 155 T310 125 T345 115",
    stroke: "#ff6a00",
    strokeWidth: 3,
    fill: "none",
    strokeLinecap: "round"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 155,
    cy: 195,
    r: 5,
    fill: "#ff6a00"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 235,
    cy: 155,
    r: 5,
    fill: "#ff6a00"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 310,
    cy: 125,
    r: 5,
    fill: "#ff6a00"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 345,
    cy: 115,
    r: 5,
    fill: "#ff6a00"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 200,
    width: 90,
    height: 110,
    rx: 10,
    fill: "white",
    stroke: "#e2e8f0",
    strokeWidth: 2
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 105,
    cy: 240,
    r: 22,
    fill: "url(#grad2)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M95 235 L100 245 L115 230",
    stroke: "white",
    strokeWidth: 3,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 275,
    width: 60,
    height: 8,
    rx: 4,
    fill: "#e2e8f0"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 290,
    width: 40,
    height: 6,
    rx: 3,
    fill: "#f1f5f9"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 350,
    y: 200,
    width: 90,
    height: 110,
    rx: 10,
    fill: "white",
    stroke: "#e2e8f0",
    strokeWidth: 2
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 395,
    y: 245,
    fontFamily: "Arial",
    fontSize: 24,
    fill: "url(#grad1)",
    fontWeight: "bold",
    textAnchor: "middle"
  }, "98%")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 395,
    y: 265,
    fontFamily: "Arial",
    fontSize: 10,
    fill: "#94a3b8",
    textAnchor: "middle"
  }, "\u8F6C\u5316\u7387")), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 365,
    y: 280,
    width: 60,
    height: 8,
    rx: 4,
    fill: "url(#grad3)"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 365,
    y: 295,
    width: 40,
    height: 6,
    rx: 3,
    fill: "#e2e8f0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M150 255 Q130 255 120 230",
    stroke: "#e2e8f0",
    strokeWidth: 2,
    fill: "none",
    strokeDasharray: "5,5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M350 255 Q370 255 380 230",
    stroke: "#e2e8f0",
    strokeWidth: 2,
    fill: "none",
    strokeDasharray: "5,5"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 420,
    cy: 150,
    r: 8,
    fill: "#ff6a00",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    values: "150;140;150",
    dur: "2s",
    repeatCount: "indefinite"
  }))), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 150,
    r: 6,
    fill: "#3b82f6",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    values: "150;160;150",
    dur: "2.5s",
    repeatCount: "indefinite"
  }))), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 50,
    r: 5,
    fill: "#10b981",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    values: "50;45;50",
    dur: "1.8s",
    repeatCount: "indefinite"
  }))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 250,
    y: 350,
    fontFamily: "Arial",
    fontSize: 16,
    fill: "#64748b",
    textAnchor: "middle",
    fontWeight: 500
  }, "\u5E7F\u544A\u6548\u679C\u8FFD\u8E2A \xB7 \u6570\u636E\u6E05\u6670\u53EF\u89C1")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 250,
    y: 375,
    fontFamily: "Arial",
    fontSize: 12,
    fill: "#94a3b8",
    textAnchor: "middle"
  }, "\u8BA9\u6BCF\u4E00\u5206\u5E7F\u544A\u82B1\u8D39\u90FD\u66F4\u6709\u4EF7\u503C")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginIllustration);
export default __webpack_public_path__ + "static/media/login-illustration.9f66022a3680eacf9562525e664a1c8f.svg";
export { ForwardRef as ReactComponent };